import React, { useState } from "react";
import classes from "./Answer.module.css";
import infoIcon from "../../../icons/infoIcon.svg";

//on mouse hover, want to change the image size
const Answer = ({ value, linksTo, submitAnswer, id, description, svgName }) => {
  const svg = svgName ? require(`../../../icons/${svgName}`) : null;
  const [hovered, setHovered] = useState(false);
  const [iconClicked, setIconClicked] = useState(false);

  let answerTextClasses = [classes.answerText];
  if (hovered) {
    answerTextClasses.push(classes.answerTextSelected);
  }

  let mobileHeadingClasses = [classes.mobileHeading];
  if (!description && !svg) {
    mobileHeadingClasses.push(classes.textAlign);
  }

  let mobileIconClasses = [classes.mobileInfo];
  if (iconClicked) {
    mobileIconClasses.push(classes.iconClicked);
  }

  let mobileIconClasses2 = [classes.mobileIcon];

  if (value === "Yes" || value === "No") {
    mobileIconClasses2.push(classes.yesOrNo);
  }

  return (
    // <div style={{ position: "relative" }}>
    <React.Fragment>
      <div
        className={classes.answerContainer}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={() => submitAnswer(value, id, linksTo)}
      >
        <div
          className={classes.dynamicContent}
          style={{ justifyContent: svg ? "flex-start" : "center" }}
        >
          {svg && (
            <img
              className={
                hovered && description ? classes.imageHovered : classes.image
              }
              style={{ width: svgName.includes(".png") ? "100%" : "150px" }}
              src={svg}
              alt="SVG as an image"
            />
          )}
          <span
            className={answerTextClasses.join(" ")}
            style={{ fontSize: svg ? "1.5rem" : "3rem", lineHeight: "50px" }}
          >
            {value}
          </span>
          {hovered && (
            <div
              style={{
                maxWidth: "75%",
                textAlign: "center",
                marginTop: "0.7rem",
              }}
            >
              <span className={classes.description}>{description}</span>
            </div>
          )}
        </div>
        <div className={classes.staticContent}>
          {hovered ? (
            <div className={classes.selectContainer}>
              <span>Select</span>
            </div>
          ) : (
            description && (
              <img
                style={{ margin: "0.5rem" }}
                src={infoIcon}
                width={25}
                height={25}
              />
            )
          )}
        </div>

        {svg && (
          <div className={mobileIconClasses2.join(" ")}>
            <img
              className={classes.mobileImage}
              src={svg}
              alt="SVG as an image"
            />
          </div>
        )}
        <div className={mobileHeadingClasses.join(" ")}>
          <span>{value}</span>
        </div>
        {description && (
          <div
            className={mobileIconClasses.join(" ")}
            onClick={(e) => {
              setIconClicked(!iconClicked);
              e.stopPropagation();
            }}
          >
            <img className={classes.infoIcon} src={infoIcon} />
          </div>
        )}
      </div>
      {iconClicked && (
        <div className={classes.descriptionModal}>
          <div className={classes.descriptionText}>{description}</div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Answer;
